import { DateTime } from "luxon";
import { CaretRightFill } from "react-bootstrap-icons";
import { Marker } from "react-mapbox-gl";

import { NMEAQualityCode, Status } from "../types";
import {
  getPosition,
  shortId,
  summarizeStatus,
  variantForSummary,
} from "../utils";

interface ScannerMarkerProps {
  status: Status;
  referenceTime: DateTime;
  onClick: () => void;
  minNMEAQuality: NMEAQualityCode;
}
export default function ScannerMarker({
  status,
  referenceTime,
  onClick,
  minNMEAQuality,
}: ScannerMarkerProps) {
  const variant = variantForSummary(
    summarizeStatus(status, referenceTime, minNMEAQuality),
    true
  );
  return (
    <Marker
      coordinates={getPosition(status, "latest")}
      anchor="right"
      onClick={onClick}
    >
      <div className="scanner-marker">
        <div className={`scanner-number bg-${variant}`}>
          {shortId(status.hostname)}
        </div>
        <div className={`scanner-icon text-${variant}`}>
          <CaretRightFill />
        </div>
      </div>
    </Marker>
  );
}
